<!--
 * @Descripttion:
 * @version: 2.0.0.0
 * @Author: ysanyu
 * @Date: 2020-09-09 20:07:03
 * @LastEditors: ysanyu
 * @LastEditTime: 2020-09-15 17:51:36
-->
<template>
  <div class="header">
    <van-icon class="arrow_left" @click="goBack" name="arrow-left" />
    <h1>{{ $route.meta.title }}</h1>
  </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      const { name } = this.$route
        const { code = '' } = this.$route.query
        console.log(name,code)
      if (name === 'Rent') {
        this.$router.replace('/')
      }else if(name ==='Publish' && code){
          this.$router.replace('/home')
      } else if (name === 'Pay') {
        this.$router.replace('/published')
      } else if (name === 'Published') {
        this.$router.replace('/me')
      } else if (name === 'Store' && code) {
          this.$router.replace('/home')
      } else if (name === 'StoreInfo') {
          this.$router.replace('/store')
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 80px;
    display: flex;
    align-items: center;
    background: #FF5C39;
    z-index: 10;
    .arrow_left{
      color: #fff;
      font-size: 32px;
      margin-left: 30px;
      margin-right: 4px;
      vertical-align: middle;
    }
    img {
      padding: 34px 19px 34px 30px;
      height: 28px;
    }
    h1 {
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #fff;
      flex: 1;
      margin-right: 40px;
      text-align: center;
    }
  }
</style>
